import React, { useState, useEffect } from "react";

// coponent

// apollo
import { useLazyQuery, useMutation } from "@apollo/client";

// icon
import { MdOutlineBorderColor } from "react-icons/md";

// react bootrap
import { Form, Spinner, Table } from "react-bootstrap";
import { GET_EXCHANGRATE } from "../../graphql/exchangeRate/Query";
import { UPDATE_EXCHANGERATE } from "../../graphql/exchangeRate/Mutation";
import { COLOR_APP, COLOR_WHITE, USER_KEY } from "../../constants";
import { numberFormat } from "../../helpers";
import { successUpdateSwal } from "../../helpers/sweetalert";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";

function ExRateList() {
  const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
  const [ExchangeRate, setExchangeRate] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [editData, setEditData] = useState({});
  const { height, width } = useWindowDimensions();

  // ======== Query And Mutation ==========

  const [LoadExchangeRate, { data: GetExchangeRate, loading }] = useLazyQuery(
    GET_EXCHANGRATE,
    { fetchPolicy: "cache-and-network" }
  );
  const [updateExchangerate, { loading: loadingUpdate }] =
    useMutation(UPDATE_EXCHANGERATE);

  // ======== useEffect ==========

  console.log("GetExchangeRate====>>>", GetExchangeRate);

  useEffect(() => {
    _fetchExchangeRate();
  }, []);

  useEffect(() => {
    if (GetExchangeRate)
      setExchangeRate([
        {
          id: GetExchangeRate?.exchangeRate?.id,
          currency: "ບາດ",
          exchangeRate: GetExchangeRate?.exchangeRate?.baht,
        },
        {
          id: GetExchangeRate?.exchangeRate?.id,
          currency: "ໂດລາ",
          exchangeRate: GetExchangeRate?.exchangeRate?.usd,
        },
      ]);
  }, [GetExchangeRate]);

  // ======== Fuction ==========

  const _fetchExchangeRate = async () => {
    await LoadExchangeRate({
      variables: {
        where: {
          shop: shopId,
        },
      },
    });
  };

  // ========== update ExchangeRate ==========
  const _updateExchangerate = async () => {
    // console.log(editData?.exchangeRate)
    try {
      // TODO: Check currency to update
      let _newExchangeRate;
      if (editData?.currency === "ບາດ")
        _newExchangeRate = { baht: parseFloat(editData?.exchangeRate) };
      else _newExchangeRate = { usd: parseFloat(editData?.exchangeRate) };
      // console.log({ _newExchangeRate })
      if (loadingUpdate) return;
      await updateExchangerate({
        variables: {
          where: {
            id: editData?.id,
          },
          data: _newExchangeRate,
        },
      });

      setIsEdit(false);
      setEditIndex();
      setEditData({});
      successUpdateSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
      _fetchExchangeRate();
    } catch (err) {
      // errorSwal('ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ')
      console.log("error creating todo:", err);
    }
  };

  // ================ Edit in box ========
  const onEditData = async (data, index) => {
    setIsEdit(true);
    setEditIndex(index);
    setEditData(data);
  };

  const onCancelEditData = async () => {
    setIsEdit(false);
    setEditIndex();
    setEditData({});
  };

  if (loading && !GetExchangeRate) return <Spinner />;

  return (
    <React.Fragment>
      <div
        style={{
          background: "#FFFFFF",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: "#3C169B",
          }}
        >
          {/* <span style={{ fontSize: "24px", color: "#6B7280" }}>
              ແກ້ໄຂເລດເງິນ
            </span> */}
          <span>
            {/* <CustomButton width="165px" height="46px" title="ເພີ່ມປະເພດ" icon={<AddBoxOutlinedIcon />} borderRadius="8px" /> */}
          </span>
        </div>

        {/* table */}

        <Table
          style={{
            borderCollapse: "collapse",
            width: "100% ",
          }}
        >
          <thead style={{ background: COLOR_APP, color: COLOR_WHITE }}>
            <tr>
              {/* <th>ລ/ດ</th> */}
              <th>ສະກຸນເງີນ</th>
              <th>ອັດຕາແລກປ່ຽນ</th>
              <th align="right">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "end",
                    alignItems: "center",
                  }}
                >
                  ຈັດການ
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {ExchangeRate?.map((ex, index) => {
              return (
                <tr key={ex + index}>
                  {/* <td style={{ paddingTop: "1rem" }}>{index + 1}</td> */}
                  <td style={{ paddingTop: "1rem" }}>
                    &ensp;
                    {index + 1 + ". " + ex?.currency}
                  </td>
                  <td style={{ paddingTop: "1rem" }}>
                    {isEdit == true && editIndex === index ? (
                      <Form.Control
                        type="text"
                        name="baht"
                        onChange={(e) => {
                          let _data = editData;
                          _data = {
                            ...editData,
                            exchangeRate: e?.target?.value,
                          };
                          setEditData(_data);
                        }}
                        value={editData?.exchangeRate}
                        placeholder="ຈຳນວນເງິນ..."
                        style={{
                          border: editData.exchangeRate ? "" : "solid 1px red",
                          width: "100px",
                        }}
                      />
                    ) : (
                      <div style={{ widht: "10em" }}>
                        {numberFormat(ex?.exchangeRate)}
                      </div>
                    )}
                  </td>

                  {isEdit == true && editIndex === index ? (
                    <td style={{ width: "auto" }} align="right">
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "end",
                          alignItems: "center",
                        }}
                      >
                       
                        <button
                          style={{
                            border: "none",
                            background: "red",
                            color: "#fff",
                            padding: ".5em 1.5em",
                            borderRadius: ".3em",
                          }}                          
                          onClick={() => onCancelEditData()}

                        >
                          <FontAwesomeIcon
                            icon={faCancel}
                            style={{ marginRight: "10px" }}
                          />
                         {"ຍົກເລີກ"}
                        </button>
                        &ensp; 
                        <button
                          style={{
                            border: "none",
                            background: COLOR_APP,
                            color: "#fff",
                            padding: ".5em 1.5em",
                            borderRadius: ".3em",
                          }}
                          onClick={() => _updateExchangerate()}

                        >
                          <FontAwesomeIcon
                            icon={faEdit}
                            style={{ marginRight: "10px" }}
                          />
                         {loadingUpdate ? <Spinner /> : "ບັນທືກ"}
                        </button>
                      </div>
                    </td>
                  ) : (
                    <td style={{ width: "auto" }}>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "end",
                          alignItems: "center",
                        }}
                      >
                        <button
                          style={{
                            border: "none",
                            background: COLOR_APP,
                            color: "#fff",
                            padding: ".5em 1.5em",
                            borderRadius: ".3em",
                          }}
                          onClick={() => onEditData(ex, index)}
                        >
                          <FontAwesomeIcon
                            icon={faEdit}
                            style={{ marginRight: "10px" }}
                          />
                          {width > 700 ? "ອັບເດດ" : ""}
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>

        {/* end table */}
      </div>
    </React.Fragment>
  );
}

export default ExRateList;
